import type { $Fetch } from 'nitropack';
import type { BFFResponse } from '~/types/BFFResponse';
import type { Category } from '~/types/GraphQL';

export default ($fetch: $Fetch) => {
  const getCategories = async () => $fetch<BFFResponse<NavbarCategory>>('/categories');

  const getCategory = async ({ key, excludeChildren }: { key: string; excludeChildren?: boolean }) => $fetch<BFFResponse<Category>>(`/categories/${key}`, { query: { excludeChildren } });

  return {
    getCategories,
    getCategory,
  };
};
